export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M12 3a.75.75 0 0 1 .713.518l1.88 5.785h6.082a.75.75 0 0 1 .44 1.356l-4.92 3.575 1.88 5.785a.75.75 0 0 1-1.154.837l-4.92-3.575-4.922 3.575a.749.749 0 0 1-1.153-.837l1.879-5.785-4.92-3.575a.75.75 0 0 1 .44-1.356h6.082l1.88-5.785A.75.75 0 0 1 12 3Z"/>
</svg>
`;
